import { MsalProvider, useAccount } from "@azure/msal-react";
import { useSession, useUserIdentification } from "@sg-protect/shell";
import { type PropsWithChildren, use, useEffect } from "react";
import { initializeMsal, msalInstance } from "./api/auth/msal.ts";

export function MsalInitializer({ children }: PropsWithChildren) {
    use(initializeMsal()); // This could be replaced by a createPublicClientApplication where we create the instance here as suggested by MSAL v3

    return (
        <MsalProvider instance={msalInstance}>
            <TenantIdentityInitializer>{children}</TenantIdentityInitializer>
        </MsalProvider>
    );
}

function TenantIdentityInitializer({ children }: PropsWithChildren) {
    const session = useSession();
    const account = useAccount();
    const { identifyMicrosoftUser } = useUserIdentification();

    useEffect(() => {
        if (account) {
            identifyMicrosoftUser(session.accountId, account.localAccountId, account.tenantId);
        }
    }, [identifyMicrosoftUser, session, account]);

    return children;
}
